import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Resets the window scroll to the top whenever the route changes via a normal
 * navigation (clicking a link/card). On back/forward ("POP") it does nothing,
 * letting the browser restore the previous scroll position — so returning to a
 * listing keeps your place, but opening a car detail always starts at the top.
 */
const ScrollToTop = () => {
    const { pathname } = useLocation();
    const navigationType = useNavigationType();

    useEffect(() => {
        if (navigationType !== "POP") {
            window.scrollTo(0, 0);
        }
    }, [pathname, navigationType]);

    return null;
};

export default ScrollToTop;
